import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CorporateCardDataDto } from '../types';
import { StaticStorage } from '../static-storage';
import { Observable, tap } from 'rxjs';
import { httpRetry } from '$core/helpers/http-retry';

@Injectable({
  providedIn: 'root',
})
export class CorporateCardInfoService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getCorporateCardStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/corporate-card-data').pipe(
      httpRetry(5),
      tap((res: CorporateCardDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
